module.exports = __webpack_public_path__ + "static/media/job_turnovers.3fe01bbf.jpg";